// Shared phone-number formatting + normalization used by api, web, and site so
// every surface stores and renders numbers identically:
//   - storage / wire form:   E.164  "+15551234567"        via toE164()
//   - US display:            national "(555) 123-4567"    via formatPhoneDisplay()
//   - international display:  "+44 20 7946 0958"           via formatPhoneDisplay()
//   - live input:            as-you-type grouping         via formatAsYouType()
//
// Backed by libphonenumber-js. The default region is US: bare 10/11-digit
// numbers parse as US; a leading "+<country code>" parses as that country.
import { parsePhoneNumberFromString, AsYouType, } from 'libphonenumber-js';
const DEFAULT_COUNTRY = 'US';
// Normalize arbitrary user input to canonical E.164 ("+15551234567"), or null
// when the input can't be parsed as a valid number. Endpoints that must never
// reject input (public intake forms) fall back to the raw trimmed string.
export function toE164(input, defaultCountry = DEFAULT_COUNTRY) {
    const trimmed = input.trim();
    if (trimmed === '')
        return null;
    const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
    if (!parsed || !parsed.isValid())
        return null;
    return parsed.number;
}
// Display form: US numbers as national "(555) 123-4567"; every other country in
// international form with its country code "+44 20 7946 0958". Input that can't
// be parsed is returned unchanged so we never blank out existing data.
export function formatPhoneDisplay(stored, defaultCountry = DEFAULT_COUNTRY) {
    if (stored == null)
        return '';
    const trimmed = stored.trim();
    if (trimmed === '')
        return '';
    const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
    if (!parsed)
        return trimmed;
    return parsed.country === 'US'
        ? parsed.formatNational()
        : parsed.formatInternational();
}
// Live "as you type" formatting for controlled inputs: returns the formatted
// partial as the user types, defaulting to US grouping until a leading "+"
// selects a different country.
export function formatAsYouType(input, defaultCountry = DEFAULT_COUNTRY) {
    return new AsYouType(defaultCountry).input(input);
}
//# sourceMappingURL=phone.js.map